import React from "react";
import { SocialPost } from "../../../types/collaborations/CollaborationTypes";

import "./style.scss";

interface SocialPostCardV2Props {
    post: SocialPost;
    onPostClick: (postId: string) => void;
}

const SocialPostCardV2: React.FC<SocialPostCardV2Props> = ({ post, onPostClick }) => {
    const handleClick = () => onPostClick(post.uuid);

    const thumb = post.thumbnail_url;

    if (!thumb) {
        return (
            <button type="button" className="social-post-card-v2" onClick={handleClick}>
                <span className="social-post-card-v2__fallback" />
            </button>
        );
    }

    return (
        <button
            type="button"
            className="social-post-card-v2"
            onClick={handleClick}
            style={{ backgroundImage: `url(${thumb})` }}
            aria-label="Open post"
        />
    );
};

export default SocialPostCardV2;

